// Shared by rendering and timezone arithmetic; keep this module free of runtime dependencies.
let localTimezoneOverride: null | string | undefined = null;

export function getLocalTimezoneOverride() {
  return localTimezoneOverride;
}

/** Internal: overrideLocalTimezone validates support before updating this context. */
export function setLocalTimezoneOverride(timeZone: null | string | undefined) {
  localTimezoneOverride = timeZone;
}
